import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import Portrait from '../components/portrait/Portrait';
import Contact from '../components/contact/Contact';
import Skills from '../components/Skills/Skills';
import Projects from '../components/Projects/Projects';
import LinkedInPosts from '../components/LinkedInPosts/LinkedInPosts';
import VideoCv from '../components/video/VideoCv';

// Données structurées de la vidéo de présentation (résultats vidéo Google)
const VIDEO_LD = {
  '@context': 'https://schema.org',
  '@type': 'VideoObject',
  name: 'Axel Grégoire — mon CV en 86 secondes',
  description: "Vidéo de présentation en motion design : parcours (quinze ans de commerce puis développeur depuis 2023), 36 compétences, projets dont l'application Lunello.",
  thumbnailUrl: ['https://axelgregoire.fr/video/axel-gregoire-cv-1600.webp'],
  uploadDate: '2026-10-08',
  duration: 'PT1M26S',
  contentUrl: 'https://axelgregoire.fr/video/axel-gregoire-cv-1080.mp4',
  inLanguage: 'fr',
  creator: { '@type': 'Person', name: 'Axel Grégoire', url: 'https://axelgregoire.fr' },
};

const Home = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const navigate = useNavigate();

  const openContactModal = () => setIsContactOpen(true);
  const closeContactModal = () => setIsContactOpen(false);

  // CV en ligne (/cv), imprimable en PDF — remplace l'ancien PDF hébergé
  const openCV = () => navigate('/cv');

  return (
    <div>
      <Helmet>
        <title>Axel Grégoire - Développeur Web Full Stack | React, Node.js</title>
        <meta name="description" content="Portfolio d'Axel Grégoire, développeur web full stack spécialisé en React, Node.js, MongoDB et PocketBase. Découvrez mes projets et contactez-moi." />
        <link rel="canonical" href="https://axelgregoire.fr/" />
        <script type="application/ld+json">{JSON.stringify(VIDEO_LD)}</script>
      </Helmet>
      <Portrait openContactModal={openContactModal} />
      <div className="informations">
        <div className="CardVideo">
          <VideoCv onOpenCv={openCV} />
        </div>
        <div className="CardSkill">
          <Skills />
        </div>
        <div id="projects">
          <Projects />
        </div>
        <div id="linkedin">
          <LinkedInPosts />
        </div>
      </div>
      <Contact isOpen={isContactOpen} onClose={closeContactModal} />
    </div>
  );
};

export default Home;
